import { render, staticRenderFns } from "./Quotation.vue?vue&type=template&id=17cefc6c&scoped=true"
import script from "./Quotation.vue?vue&type=script&lang=ts"
export * from "./Quotation.vue?vue&type=script&lang=ts"
import style0 from "./Quotation.vue?vue&type=style&index=0&id=17cefc6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17cefc6c",
  null
  
)

export default component.exports